import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './core/login/login.component';
import { AuthGuardService } from './core/auth/auth-guard.service';
import { PrincipalComponent } from './features/page/principal/principal.component';
import { ForgotPasswordComponent } from './core/password/forgot-password/forgot-password.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'principal',
    pathMatch: 'full'
  },
  {
    path: 'features',
    component: PrincipalComponent,
    // loadChildren: './features/features.module#FeaturesModule',
    loadChildren: () => import('./features/features.module').then(m => m.FeaturesModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'not-found',
    redirectTo: 'features'
  },
  {
    path: '**',
    redirectTo: 'features'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
